// Full A–Z reference: each letter with its phonetic sound and an example word.
// Used by the AZSounds section shown on both track pages.
export const ALPHABET_SOUNDS = [
  { letter: "A", sound: "a", word: "apple" },
  { letter: "B", sound: "b", word: "ball" },
  { letter: "C", sound: "k", word: "cat" },
  { letter: "D", sound: "d", word: "dog" },
  { letter: "E", sound: "e", word: "egg" },
  { letter: "F", sound: "f", word: "fish" },
  { letter: "G", sound: "g", word: "goat" },
  { letter: "H", sound: "h", word: "hat" },
  { letter: "I", sound: "i", word: "igloo" },
  { letter: "J", sound: "j", word: "juice" },
  { letter: "K", sound: "k", word: "kite" },
  { letter: "L", sound: "l", word: "lion" },
  { letter: "M", sound: "m", word: "moon" },
  { letter: "N", sound: "n", word: "nest" },
  { letter: "O", sound: "o", word: "orange" },
  { letter: "P", sound: "p", word: "pig" },
  { letter: "Q", sound: "kw", word: "queen" },
  { letter: "R", sound: "r", word: "rain" },
  { letter: "S", sound: "s", word: "sun" },
  { letter: "T", sound: "t", word: "tree" },
  { letter: "U", sound: "u", word: "umbrella" },
  { letter: "V", sound: "v", word: "van" },
  { letter: "W", sound: "w", word: "web" },
  { letter: "X", sound: "ks", word: "box" },
  { letter: "Y", sound: "y", word: "yarn" },
  { letter: "Z", sound: "z", word: "zebra" },
];
